<template>
    <v-dialog :value="value" @input="$emit('input', false)" max-width="400">
        <v-card>
            <v-card-title>{{ title }}</v-card-title>

            <v-card-text>
                <v-form @submit.prevent="ok" ref="form" v-model="valid">
                    <v-text-field
                        ref="inputField"
                        v-model="input"
                        :label="label"
                        :rules="fieldRules"
                    ></v-text-field>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="cancel" text>{{ cancelText }}</v-btn>
                <v-btn @click="ok" text color="primary">{{ okText }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },

        title: {
            type: String,
            required: true
        },

        label: {
            type: String,
            required: true
        },

        intialValue: {
            type: String,
        },

        cancelText: {
            type: String,
            default: 'Batal'
        },

        okText: {
            type: String,
            default: 'OK'
        }
    },

    data() {
        return {
            input: null,

            valid: null,

            fieldRules: [
                v => !!v || `${this.label} harus diisi`
            ]
        }
    },

    watch: {
        value(to) {
            if (to) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.form.reset()

                        if (this.initialValue) {
                            this.input = this.initialValue
                        }

                        this.$refs.inputField.focus()
                    })
                })
            }
        },
    },

    methods: {
        ok() {
            if (this.valid) {
                this.$emit('ok', this.input)
                this.$emit('input', false)
            }
        },

        cancel() {
            this.$emit('cancel')
            this.$emit('input', false)
        }
    },
}
</script>
